export const customers = [
    {
        title: 'Brasília Segurança',
        img: 'logo-bsb-seg.png'
    },
    {
        title: 'Setedezessete',
        img: 'logo-setedezessete.png'
    },
    {
        title: 'Heliane Resende Eventos',
        img: 'heliane-resende-eventos-logo.png'
    },
    {
        title: 'Heliane Resende Eventos',
        img: 'heliane-resende-eventos-logo.png'
    },
    {
        title: 'Setedezessete',
        img: 'logo-setedezessete.png'
    },
    {
        title: 'Brasília Segurança',
        img: 'logo-bsb-seg.png'
    },
]

export const products = [
    {
        title: 'UNIFORME XPTA',
        img: 'uniforme-a.jpg'
    },
    {
        title: 'UNIFORME XPTB',
        img: 'uniforme-b.jpg'
    },
    {
        title: 'UNIFORME XPTC',
        img: 'uniforme-c.png'
    },
    {
        title: 'UNIFORME XPTD',
        img: 'uniforme-d.jpg'
    },
    {
        title: 'UNIFORME XPTE',
        img: 'uniforme-e.jpg'
    },
    {
        title: 'UNIFORME XPTF',
        img: 'uniforme-f.jpg'
    }
]

const loadEntries = entries => {
    Promise.all(
        entries.map(entry => {
            console.log(entry.img)
            if (entry.img) {
                import(`../media/${entry.img}`)
            }
        })
    )
}


// loadEntries(customers)
// loadEntries(products)
